import React from 'react';
import styles from './components.module.scss';

export default function SectionTitle({ title }) {
  return <h1 className={styles.title}>{title}</h1>;
}
